import {fork} from 'redux-saga/effects';
import LandingSaga from '../components/Landing/sagas/LandingSaga'
import CommonSaga from '../components/common/commonSaga'
function* rootSaga() {
    yield fork(LandingSaga);    
    yield fork(CommonSaga);
} 

export default rootSaga